import React, { Component, Fragment } from 'react';
import FaqPage from 'components/Faq';
import { HeaderUnLoggedIn, HeaderLoggedIn } from 'scenes/Header';
import Footer from 'scenes/Footer';
import connect from 'react-redux/es/connect/connect';
import * as actions from 'store/modules/links';

class Faq extends Component {
  static propTypes = {};

  render() {
    const { isLoggedIn } = this.props;

    return (
      <Fragment>
        {isLoggedIn ? <HeaderLoggedIn /> : <HeaderUnLoggedIn />}
        <FaqPage />
        <Footer />
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    isLoggedIn: state.auth.isUserLoggedIn,
  };
}
export default connect(
  mapStateProps,
  actions,
)(Faq);



// WEBPACK FOOTER //
// ./src/scenes/Faq/Faq.js